module.exports = __webpack_public_path__ + "img/Wp_2040.1a01bc6e.png";